import { render, staticRenderFns } from "./BEEhome.vue?vue&type=template&id=24259d00&scoped=true&"
import script from "./BEEhome.vue?vue&type=script&lang=js&"
export * from "./BEEhome.vue?vue&type=script&lang=js&"
import style0 from "./BEEhome.vue?vue&type=style&index=0&id=24259d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24259d00",
  null
  
)

export default component.exports